/** Authenticated API. Pending mutations keep the same ID through retries/reloads. */
export async function penaltyRequest(operation, body, initData) {
  if (!initData) throw new Error("Пенальти доступны внутри Telegram");
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch(`/api/penalty/${operation}`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...body, initData }), signal: controller.signal,
    });
    const payload = await response.json();
    if (!response.ok) {
      const error = new Error(payload.error || "Не удалось выполнить действие");
      error.status = response.status;
      throw error;
    }
    return payload;
  } catch (error) {
    if (error.name === "AbortError" || error instanceof TypeError) {
      throw new Error("Связь прервалась. Восстановите раунд — ставка не спишется повторно");
    }
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }
}

export function pendingKey(userId) {
  return `metacard-penalty-pending:${userId}`;
}

export function readPending(storage, key) {
  const raw = storage.getItem(key);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    if (!["start", "shoot", "cashout"].includes(value.operation) ||
        typeof value.body?.requestId !== "string") throw new Error("invalid_pending");
    return value;
  } catch {
    storage.removeItem(key);
    return null;
  }
}

export function clearPending(storage, key, requestId) {
  const saved = readPending(storage, key);
  if (saved?.body.requestId === requestId) storage.removeItem(key);
}

export function currentRound(result) {
  // A replay contains the old action result and the current active round.
  // Never replace a newer round with a snapshot of a previous action.
  return result.activeRound || result.round || null;
}
